(function() {
  var loadedScripts = {};

  function activateScript(script) {
    var source = script.getAttribute('data-src');
    if (source) {
      script.setAttribute('src', source);
      script.removeAttribute('data-src');
      return;
    }

    if (script.getAttribute('type') !== 'text/javascripts') {
      return;
    }

    var replacement = document.createElement('script');
    Array.prototype.slice.call(script.attributes).forEach(function(attribute) {
      if (attribute.name !== 'type') {
        replacement.setAttribute(attribute.name, attribute.value);
      }
    });
    replacement.type = 'text/javascript';
    replacement.innerHTML = script.innerHTML;
    script.parentNode.insertBefore(replacement, script);
    script.parentNode.removeChild(script);
  }

  function loadGroup(trigger) {
    if (loadedScripts[trigger]) return;
    loadedScripts[trigger] = true;

    var selector = 'script[data-src][data-load-trigger="' + trigger + '"],script[type="text/javascripts"][data-load-trigger="' + trigger + '"]';
    document.querySelectorAll(selector).forEach(activateScript);

    document.dispatchEvent(new CustomEvent('theme:deferred-scripts:' + trigger));
  }

  function loadDefaultIdle() {
    document.querySelectorAll('script[data-src]:not([data-load-trigger]),script[type="text/javascripts"]:not([data-load-trigger])').forEach(activateScript);
    loadGroup('idle');
    document.dispatchEvent(new CustomEvent('StartAsyncLoading'));
    document.dispatchEvent(new CustomEvent('startasyncloading'));
  }

  function loadViewportScripts() {
    var scripts = document.querySelectorAll('script[data-load-trigger="viewport"]');
    if (!scripts.length) return;
    if (!('IntersectionObserver' in window)) {
      loadGroup('viewport');
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        loadGroup('viewport');
      });
    }, { rootMargin: '320px 0px' });
    scripts.forEach(function(script) {
      observer.observe(script);
    });
  }

  function bindIntentGroup(selector, trigger) {
    document.addEventListener('click', function(event) {
      if (!event.target || !event.target.closest(selector)) return;
      loadGroup(trigger);
    }, true);
  }

  window.themeDeferredScriptLoader = {
    load: loadGroup,
    loadIdle: loadDefaultIdle
  };

  loadViewportScripts();
  bindIntentGroup('[data-chat-trigger],.chat-button,.chatBtn,.js-chat-trigger', 'chat');
  bindIntentGroup('#cartLink,[data-cart-trigger="drawer"],form[action*="/cart/add"] button[type="submit"]', 'cart');

  window.addEventListener('load', function() {
    window.setTimeout(loadDefaultIdle, 9000);
  }, false);
})();
